const COURSE_TYPES = ['family', 'single', 'friends', 'double', 'hybrid', 'dealer', 'healer', 'tanker', 'n86', 'x', 'm', 'z'];

// for sitemap-generator (module only)
module.exports = COURSE_TYPES;
